// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { companiesModel } from '@/firebase/firebase-config'

export const GetCompany = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        company: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getCompanyHandler: async function() {

            try {

                companiesModel.doc(this.user.relationships.company).get()
                .then(doc => {

                    if (!doc.exists) return;

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.company = doc.data();

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Company from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Company',
                        uid: 'VWzhpkqtpGv8lrGcOaoA',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Get the Company Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Company',
                    uid: 'zUcoaHXAPbTGB2kmKZxT',
                    error: e
                });

            }

        }

    }

}